export const DENIED_EMAIL_CHARS_REGEX = /[!#$&'*\/=?^`{|}~–]+/gim;

export const EMAIL_FORMAT = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
